<template>
  <div>
    <cx-dialog v-if='showTotalForm'
               :visible="showTotalForm"
               :title='title'
               width="70%"
               :top="'3vh'"
               :showOkBtn="false"
               @close='showTotalForm = false'>
      <div style="margin-bottom:28px">
        <el-table v-loading="loading" :data="totalData"
                  border
                  highlight-page-row
                  size='mini'
                  style="width:100%;">
          <el-table-column prop="client_name" label="公司名称" width="200"></el-table-column>
          <el-table-column prop="client_total" label="社保-单位缴费合计" width="140" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="person_total" label="社保-个人缴费合计" width="140" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="total" label="社保-合计" width="100" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="fund_client" label="公积金-单位缴费合计" width="140" align="right" :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="fund_person" label="公积金-个人缴费合计" width="140" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="total_amount" label="公积金-合计" width="100" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="com_sum" label="单位合计" width="100" align="right"  :formatter="Filter.fmMoney"></el-table-column>
          <el-table-column prop="emp_sum" label="个人合计" width="100" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        </el-table>
      </div>
    </cx-dialog>

    <cx-dialog v-if='showForm'
               :visible="showForm"
               :title='title'
               :model='form'
               width="50%"
               :top="'3vh'"
               @close='showForm = false'>
      <div style="margin-bottom:28px">
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
          <el-col :span="6">
            <h3>基本信息</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            姓名:{{selectedRows[0].emp_name}}
          </el-col>
          <el-col :span="6">
            身份证号:{{selectedRows[0].id_card}}
          </el-col>
          <el-col :span="6">
            户口类型:{{selectedRows[0].employeeDetail.hold_nature}}
          </el-col>
          <el-col :span="6">
            参保月份:{{selectedRows[0].begin_date}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            缴纳类型:{{selectedRows[0].status | hrDetailStatus}}
          </el-col>
          <el-col :span="6">
            社保参保地:{{selectedRows[0].employeeDetail.insured_area_s}}
          </el-col>
          <el-col :span="6">
            公积金参保地:{{selectedRows[0].employeeDetail.insured_area_f}}
          </el-col>
        </el-row>
      </div>
      <div style="line-height: 3;margin-bottom:28px">
        <el-row>
          <el-col :span="24">
            <hr>
          </el-col>
          <el-col :span="6">
            <h3>&nbsp;&nbsp;费用信息</h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <h4>类别</h4>
          </el-col>
          <el-col :span="4">
            <h4>缴纳项目</h4>
          </el-col>
          <el-col :span="4">
            <h4>基数</h4>
          </el-col>
          <el-col :span="4">
            <h4>个人缴费</h4>
          </el-col>
          <el-col :span="4">
            <h4>单位缴费</h4>
          </el-col>
          <el-col :span="4">
            <h4>小计</h4>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <h5></h5>
          </el-col>
          <el-col :span="4">
            <span>养老保险</span>
          </el-col>
          <el-col :span="4">
            {{form.pu_base | fm}}
          </el-col>
          <el-col :span="4">
            {{form.pension_person | fm}}
          </el-col>
          <el-col :span="4">
            {{form.pension_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.pension_person + form.pension_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <h5></h5>
          </el-col>
          <el-col :span="4">
            <span>基本医疗</span>
          </el-col>
          <el-col :span="4">
            {{form.ibh_base | fm}}
          </el-col>
          <el-col :span="4">
            {{form.hosp_person | fm}}
          </el-col>
          <el-col :span="4">
            {{form.hosp_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.hosp_person + form.hosp_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <span>社保</span>
          </el-col>
          <el-col :span="4">
            <span>失业保险</span>
          </el-col>
          <el-col :span="4">
            {{form.pu_base | fm}}
          </el-col>
          <el-col :span="4">
            {{form.unemp_person | fm}}
          </el-col>
          <el-col :span="4">
            {{form.unemp_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.unemp_person + form.unemp_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <h5></h5>
          </el-col>
          <el-col :span="4">
            <span>工伤保险</span>
          </el-col>
          <el-col :span="4">
            {{form.ibh_base | fm}}
          </el-col>
          <el-col :span="4">
            0.00
          </el-col>
          <el-col :span="4">
            {{form.injuries_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.injuries_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <h5></h5>
          </el-col>
          <el-col :span="4">
            <span>生育保险</span>
          </el-col>
          <el-col :span="4">
            {{form.ibh_base | fm}}
          </el-col>
          <el-col :span="4">
            0.00
          </el-col>
          <el-col :span="4">
            {{form.bear_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.bear_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <span>公积金</span>
          </el-col>
          <el-col :span="4">
            <span>公积金</span>
          </el-col>
          <el-col :span="4">
            {{form.fu_base | fm}}
          </el-col>
          <el-col :span="4">
            {{form.fund_person | fm}}
          </el-col>
          <el-col :span="4">
            {{form.fund_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.fund_person + form.fund_client | fm}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            合计
          </el-col>
          <el-col :span="4">
            -
          </el-col>
          <el-col :span="4">
            -
          </el-col>
          <el-col :span="4">
            {{form.pension_person + form.hosp_person + form.unemp_person + form.fund_person | fm}}
          </el-col>
          <el-col :span="4">
            {{form.pension_client + form.hosp_client + form.unemp_client + form.injuries_client + form.bear_client + form.fund_client | fm}}
          </el-col>
          <el-col :span="4">
            {{form.pension_person + form.pension_client + form.hosp_person + form.hosp_client + form.unemp_person + form.unemp_client + form.injuries_client + form.bear_client + form.fund_person + form.fund_client | fm}}
          </el-col>
        </el-row>
      </div>
    </cx-dialog>

    <cx-query-condition :loading="loading" @query="query"
                        @reset='resetQueryCondition'>
      <el-row>
        <el-col :span="6">
          <el-form-item label="员工姓名">
            <cx-input v-model="queryCondition.name"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <cx-select v-model="queryCondition.type" :options="insTypeList"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="月份">
            <cx-date-picker v-model="queryCondition.curr_date" type="month" placeholder="选择日期" value-format="yyyy-MM-dd" size="mini"></cx-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </cx-query-condition>

    <cx-btn-group>
          <el-button type="success" icon="el-icon-refresh" size='mini' :loading="loading"
                     @click='query'>刷新</el-button>
      <el-button type="primary" icon="el-icon-document" size='mini' :loading="loading"
                 @click='total'>在缴保险合计</el-button>
      <el-button type="warning" icon="el-icon-info" size='mini' :loading="loading"
                 @click='detail'>详情</el-button>
    </cx-btn-group>

    <div>
      <el-row>
        <el-col :span="24">
          <h3>在缴人员明细</h3>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:18px">
        <el-col :span="24">
          <hr>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:18px">
        <el-col :span="24">
          <span style="color:gray">&nbsp;&nbsp;温馨提示：在缴员工参保明细展示的为单位实际在保人员情况， 每月25日提供。</span>
        </el-col>
      </el-row>
      <el-row style="margin-bottom:18px">
        <el-col :span="24">
          <hr>
        </el-col>
      </el-row>
      <el-table v-loading="loading" :data="data"
                border
                highlight-page-row
                size='mini'
                style="width:100%;"
                @selection-change='handleSelectionChange'>
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="emp_name" label="姓名" width="100"></el-table-column>
        <el-table-column prop="id_card" label="身份证号" width="160"></el-table-column>
        <el-table-column prop="status" label="状态" width="100"></el-table-column>
        <el-table-column prop="client_total" label="社保-单位缴费" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="person_total" label="社保-个人缴费" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="total" label="社保-合计" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="fund_client" label="公积金-单位缴费" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="fund_person" label="公积金-个人缴费" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="total_amount" label="公积金-合计" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="com_sum" label="单位合计" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
        <el-table-column prop="emp_sum" label="个人合计" width="120" align="right"  :formatter="Filter.fmMoney"></el-table-column>
      </el-table>
    </div>
    <cx-pagination :pageData="queryCondition"
                   @sizeChange='query'
                   @pageChange='query' />

  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        data: [],
        selectedRows: [],

        showForm: false,
        showTotalForm: false,
        totalData: [],
        billStatusList: [],
        serTypeList: [],
        insTypeList: [],
        form: {
        },

        queryCondition: {
          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.ROWS,

          name: '',
          type: null,
          curr_date: this.moment(Date.now()).format("YYYY-MM-01"),
        },
        title: '',
      }
    },
    mounted() {
      this.queryDictionaries(this.query);
    },
    methods: {
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      queryDictionaries(callback) {
        this.post('/sys-dictionaries/list', {
            types: '52, 53, 54',
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.MAX_ROWS,
        }).then(resp => {
          if (resp) {
            if (resp.data.success) {
              let rows = resp.data['rows'] || [];
              rows.forEach(row => {
                switch (row.type) {
                  case 52:
                    this.billStatusList.push(row);
                    break;
                  case 53:
                    this.serTypeList.push(row);
                    break;
                  case 54:
                    this.insTypeList.push(row);
                    break;
                }
              });
              if(callback){
                callback();
              }
            }
          }
        });
      },
      query() {
        this.loading = true;
        this.showForm = false;
        this.showTotalForm = false;
        let postData = this._.cloneDeep(this.queryCondition);
        if(!postData.type){
          postData.type = this.insTypeList[0].id;
        }
        this.post('/social/social-fund-detail', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              let data = resp.data['rows'] || [];
              for(let i=0;i<data.length;i++){
                if(!data[i].pension_person){
                  data[i].pension_person = 0;
                }
                if(!data[i].pension_client){
                  data[i].pension_client = 0;
                }
                if(!data[i].client_total){
                  data[i].client_total = 0;
                }
                if(!data[i].person_total){
                  data[i].person_total = 0;
                }
                if(!data[i].total){
                  data[i].total = 0;
                }
                if(!data[i].total){
                  data[i].total = 0;
                }
                if(!data[i].hosp_person){
                  data[i].hosp_person = 0;
                }
                if(!data[i].hosp_client){
                  data[i].hosp_client = 0;
                }
                if(!data[i].unemp_person){
                  data[i].unemp_person = 0;
                }
                if(!data[i].unemp_client){
                  data[i].unemp_client = 0;
                }
                if(!data[i].injuries_client){
                  data[i].injuries_client = 0;
                }
                if(!data[i].bear_client){
                  data[i].bear_client = 0;
                }
                if(!data[i].fund_person){
                  data[i].fund_person = 0;
                }
                if(!data[i].fund_client){
                  data[i].fund_client = 0;
                }
                if(!data[i].total_amount){
                  data[i].total_amount = 0;
                }
                if(!data[i].com_sum){
                  data[i].com_sum = 0;
                }
                if(!data[i].emp_sum){
                  data[i].emp_sum = 0;
                }
                if(!data[i].fu_base){
                  data[i].fu_base = 0;
                }
                if(!data[i].pu_base){
                  data[i].pu_base = 0;
                }
                if(!data[i].ibh_base){
                  data[i].ibh_base = 0;
                }
              }
              data.forEach(row => {
                row.employeeDetail = {};
              });
              this.data = data;
              this.queryCondition.total = resp.data['total'];
            }
          }
        })
      },
      queryClientEmployeeDetail() {
        if(this.selectedRows[0].emp_id) {
          this.post('/client-employee/list', {
            id: this.selectedRows[0].emp_id
          }).then(resp => {
            if(resp) {
              if(resp.data['success']) {
                let rows = resp.data['rows'] || [];
                if(rows && rows.length > 0) {
                  this.selectedRows[0].employeeDetail = rows[0];
                }
              }
            }
          })
        }
      },
      resetQueryCondition() {
        this.Util.reset(this.queryCondition);
        this.queryCondition.type = null;
        this.queryCondition.curr_date = this.moment(Date.now()).format("YYYY-MM-01");
      },
      total() {
        this.title = '在缴人员保险合计';
        this.showTotalForm = true;
        let postData = {};
        this.post('/social/social-fund-summary', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              this.totalData = resp.data['rows'] || {};
            }
          }
        })
      },
      detail() {
        if (this.selectedRows.length !== 1) {
          this.error(this.CONST.TIP.SELECT_ONE_FIRST);
        } else {
          this.Util.reset(this.form);
          this.title = '参保明细';
          this.form = this._.clone(this.selectedRows[0]);
          this.queryClientEmployeeDetail();
          this.showForm = true;
        }
      },
    },
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/insurance/detail/list.vue